import { render, staticRenderFns } from "./bandsale.vue?vue&type=template&id=53e54da8&scoped=true"
import script from "./bandsale.vue?vue&type=script&lang=js"
export * from "./bandsale.vue?vue&type=script&lang=js"
import style0 from "./bandsale.vue?vue&type=style&index=0&id=53e54da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e54da8",
  null
  
)

export default component.exports